import * as React from 'react';
import px from 'prop-types';
import { useSelector } from 'react-redux';
import { useAction } from 'Common/hooks';
import { LinkItem } from 'Common/types';
import { TAGS } from 'Common/constants/gtm';
import { ProductListView as ListView } from 'Common/components/product';
import { NotificationSubscription } from 'Common/containers/customer';
import { product, order, compare } from '~features';

export default function ProductListView(props) {
    const { useCompare = false, comparePageUrl = '', ...restProps } = props;

    const onAddItemToCart = useAction(order.actions.addItem);
    const onAddMultipleToCart = useAction(order.actions.addItems);

    const onGetCompareList = useAction(compare.actions.getCompareList);
    const onAddToCompareList = useAction(compare.actions.addToCompareList);
    const onRemoveFromCompareList = useAction(compare.actions.removeFromCompareList);

    const variants = useSelector(product.selectors.getChildren);
    const productInfo = useSelector(product.selectors.getProduct);
    const totalQty = useSelector(order.selectors.getTotalQuantity);

    const comparedItems = useSelector(compare.selectors.getCompareItems);
    const compareIsLoading = useSelector(compare.selectors.getLoading);

    React.useEffect(() => {
        if (useCompare) {
            onGetCompareList();
        }
    }, [useCompare, onGetCompareList]);

    return (
        <ListView
            onAddItemToCart={onAddItemToCart}
            onAddMultipleToCart={onAddMultipleToCart}
            variants={variants}
            productInfo={productInfo}
            gtmListValue={TAGS.PDP}
            NotifyMe={NotificationSubscription}
            totalQty={totalQty}
            useCompare={useCompare}
            comparePageUrl={comparePageUrl}
            comparedItems={comparedItems}
            compareIsLoading={compareIsLoading}
            onAddToCompareList={onAddToCompareList}
            onRemoveFromCompareList={onRemoveFromCompareList}
            {...restProps}
        />
    );
}

ProductListView.propTypes = {
    Links: px.node,
    storeLocatorLink: LinkItem,
    useCompare: px.oneOfType([px.bool, px.string]),
    comparePageUrl: px.string,
};
